<div mat-dialog-content>
  <p>
    Êtes-vous sûr de vouloir modifier cette commande ?
  </p>
  <p>
    Vous pourrez uniquement augmenter les quantités déjà transmises et transmettre à nouveau.
  </p>
</div>
<div mat-dialog-actions class="dialog-buttons">
  <button mat-stroked-button (click)="refuse()">Annuler</button>
  <button mat-flat-button color="primary" (click)="editSendOrder()" [disabled]="isSending">Confirmer</button>
</div>